/*** IMPORTS FROM imports-loader ***/
var define = false;

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger, SplitText);


export function splitTitle() {
  const titles = document.querySelectorAll(".splitTitle");

  function setupSplits() {
    titles.forEach(title => {
      // Reset if needed
      if(title.anim) {
        title.anim.progress(1).kill();
        title.split.revert();
      }

      title.split = new SplitText(title, {
        type: "lines,words,chars",
        linesClass: "split-line",
        wordsClass: "split-word"
      });

      // Set up the anim
      title.anim = gsap.from(title.split.words, {
        scrollTrigger: {
          trigger: title,
          toggleActions: "restart pause resume reverse",
          start: "top 80%",
          scroller: '.fullView'
        },
        duration: .65,
        ease: "power2.out",
        y: 120,
        rotate: 2.5,
        stagger: 0.01,
      });

      // $('.hero__title').addClass('animated');
    });


  }

  setTimeout(() => {
    $('.splitTitle').addClass('ready');
    setupSplits();
  }, 500);

}
